var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"cf-c-navbar__ctn-inner-plan"},[_c('p',[_vm._v(" "+_vm._s(_vm.planText)+" "),(_vm.planTextLink)?_c('span',{on:{"click":_vm.handleLink}},[_vm._v(_vm._s(_vm.planTextLink))]):_vm._e()]),_c('contact-administrator-modal')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }